/*
 * @Author: zhou lei
 * @Date: 2020-08-24 09:11:30
 * @LastEditTime: 2022-05-19 11:35:05
 * @LastEditors: zhou lei
 * @Description: Description
 * @FilePath: /mmeui/src/main.js
 * 联系方式:910592680@qq.com 科海达信息技术有限公司
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import JsonExcel from 'vue-json-excel'
import { Row, Col } from 'vant'
import VueSvgGauge from 'vue-svg-gauge'

import 'normalize.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/main.scss'
import Vant from 'vant'
import 'vant/lib/index.css'
import VScaleScreen from 'v-scale-screen'
import VueI18n from 'vue-i18n'
import messages from './i18n/index'
Vue.use(VueI18n)
Vue.use(VScaleScreen)
const i18n = new VueI18n({
    locale: localStorage.getItem('lang')||'zh', // 设置地区
    messages // 设置地区信息
})
Vue.component('downloadExcel', JsonExcel)
Vue.use(VueSvgGauge)
Vue.use(Vant)
Vue.use(Row).use(Col)
require('./utils/mock')
Vue.config.productionTip = false
Vue.use(ElementUI, {
    size: 'small',
    zIndex: 3000
})

import vmodal from 'vue-js-modal'
Vue.use(vmodal)

// 监控
import * as MITO from '@zyf2e/monitor-web'
Vue.use(MITO.MitoVue)
// MITO.init({
//   dsn: 'http://127.0.0.1:8001/base/app/eps',
//   apikey: '123-2223-123-123',
// })
Vue.prototype.$mito = MITO
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    i18n,
    components: {
        App
    },
    render: h => h(App)
})
document.title = messages[i18n.locale].home.title